import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	focusAreaType: {
		id: 'search-page.filters.names.focusAreaType',
		defaultMessage: 'Focus area type',
		description: 'Label for filtering by focus area type',
	},
	mercuryFilterFocusAreaTypePlaceholder: {
		id: 'search-page.mercury.filter.focusAreaType.placeholder',
		defaultMessage: 'Find focus area types',
		description: 'Placeholder for focus area type filter search input',
	},
	mercuryFilterFocusAreaTypeLabelSelected: {
		id: 'search-page.mercury.filter.focusAreaType.label.selected',
		defaultMessage: 'Selected',
		description: 'Focus area type filter label selected',
	},
	mercuryFilterFocusAreaTypeLabelUnselected: {
		id: 'search-page.mercury.filter.focusAreaType.label.unselected',
		defaultMessage: 'Suggested',
		description: 'Focus area type filter label unselected',
	},
});
